module.exports = __webpack_public_path__ + "static/img/jingpai.7caa5957.png";